module.exports = __webpack_public_path__ + "img/lnb_hand.92f7ef04.svg";